// extracted by mini-css-extract-plugin
export var completionBody = "_jg-2";
export var completionCard = "_jg-0";
export var completionFooter = "_jg-3";
export var completionTitle = "_jg-1";